import { render } from "./informationTransfer.vue?vue&type=template&id=3d0f6784"
import script from "./informationTransfer.vue?vue&type=script&lang=js"
export * from "./informationTransfer.vue?vue&type=script&lang=js"

import "./informationTransfer.vue?vue&type=style&index=0&id=3d0f6784&lang=scss"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__